import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-geetest',
  templateUrl: './geetest.component.html',
  styleUrls: ['./geetest.component.scss']
})
export class GeetestComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('captcha') captchaElement: ElementRef;
  @Output() success = new EventEmitter();
  @Input() btnClass = 'btn btn-primary';
  @Input() disabled = false;

  private captcha: any;
  private destroyed = false;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    (window as any).initGeetest4(
      {
        captchaId: '54c1ca48d37bd304749d68f38457bcc5',
        product: 'bind'
      },
      (captcha: any) => {
        if (this.destroyed) {
          return;
        }
        this.captcha = captcha;
        captcha.onSuccess(() => {
          this.success.emit(captcha.getValidate());
        });
      }
    );
  }

  ngOnDestroy() {
    this.destroyed = true;
  }

  reset() {
    if (!this.captcha) {
      return;
    }
    this.captcha.reset();
  }

  show() {
    this.captcha.showCaptcha();
  }
}
